import { NotOverridableComponentProps } from '../../../../../model/Component'
import { AppBox } from '../AppBox'
import Dialog, { DialogProps } from '@mui/material/Dialog'

export type AppDialogProps = NotOverridableComponentProps<DialogProps>

export function AppDialog(props: AppDialogProps) {
  return <AppBox component={Dialog} {...props} />
}
